import { handleActions, combineActions } from 'redux-actions'
import types from './types'

const INITIAL_STATE = {
  isLoading: true,
  processSteps: [],
}

const beginLoading = combineActions(
  types.LOAD_NOTICE_MANAGEMENT_PROCESS_STEPS,
  types.SET_SUBSCRIPTION
)

const stopLoading = combineActions(
  types.LOAD_NOTICE_MANAGEMENT_PROCESS_STEPS_SUCCESS,
  types.LOAD_NOTICE_MANAGEMENT_PROCESS_STEPS_FAIL
)

const reducer = handleActions(
  {
    [beginLoading]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [stopLoading]: (state) => ({
      ...state,
      isLoading: false,
    }),
    [types.LOAD_NOTICE_MANAGEMENT_PROCESS_STEPS_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      processSteps: data,
      isLoading: false,
    }),
    [types.SET_SUBSCRIPTION]: (state, { subscription }) => ({
      ...state,
      subscription,
    }),
    [types.CLEAR_STATE]: () => {
      return { ...INITIAL_STATE }
    },
  },
  INITIAL_STATE
)

export default reducer
